import moment from 'moment'

function alphaOnly(event) {
    if (!/^[a-z A-Z]*$/.test(event.key)) {
        event.preventDefault();
    }
}

function alphaNumOnly(event) {
    if (/[^0-9a-zA-Z]/.test(event.key)) {
        event.preventDefault();
    }
}

function objectHasKey(obj, key) {
    if (obj !== undefined && obj !== null && Object.keys(obj).length > 0 && obj.hasOwnProperty(key)) {
        return true
    }
    return false
}

function objectHasKeys(obj) {
    if (obj !== undefined && obj !== null && Object.keys(obj).length > 0) {
        return true
    }
    return false
}

function validateEmail(emailField) {
    var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (reg.test(emailField.value)) {
        return false;
    }
    return true;
}

function validatePassword(passwordField) {
    var reg = /^[@#][A-Za-z0-9]{8,20}$/;
    if (reg.test(passwordField.value)) {
        return false;
    }
    return true;
}

function arrayNotNull(array) {
    if (array !== undefined && array !== null && Array.isArray(array) && array.length > 0) {
        return true
    }
    return false
}

function notNull(data) {
    if (data !== undefined && data !== null && data !== '') {
        return true
    }
    return false
}

function printArrayOfObject(arr, key, seprator) {
    let temp = []
    arrayNotNull(arr) && arr.map(function (item, index) {
        temp.push(item[key])
    });
    return temp.join(seprator)
}


function defaultDate(date) {
    return moment(date).format('DD MMMM YYYY')
}

function defaultDateTime(date) {
    return moment(date).format('DD/MM/YYYY: hh:mm A')
}

function formatDateTimeLocal(date) {
    if (!date) return '';
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export { alphaNumOnly, alphaOnly, objectHasKey, objectHasKeys, validateEmail, validatePassword, arrayNotNull, notNull, defaultDate, defaultDateTime, printArrayOfObject, formatDateTimeLocal };